u.CarouselSwipe = class extends u.CarouselNav {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        // credit to http://stackoverflow.com/questions/2264072/detect-a-finger-swipe-through-javascript-on-the-iphone-and-android
        this._handleTouchStart = (evt) => {
            u.CarouselSwipe.xDown = evt.touches[0].clientX;
            u.CarouselSwipe.yDown = evt.touches[0].clientY;
        }

        this._handleTouchMove = (evt) => {
            if ( ! u.CarouselSwipe.xDown || ! u.CarouselSwipe.yDown ) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            var xDiff = u.CarouselSwipe.xDown - xUp;
            var yDiff = u.CarouselSwipe.yDown - yUp;

            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) { // most significant
                if ( xDiff > 0 ) {
                    // right swipe
                    this.$forElement.$moveTo('+1');
                } else {
                    // left swipe
                    this.$forElement.$moveTo('-1');
                }
            }
            u.CarouselSwipe.xDown = null;
            u.CarouselSwipe.yDown = null;
        }
    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('touchstart', this._handleTouchStart, false);
        this.addEventListener('touchmove', this._handleTouchMove, false);

    }

    detachedCallback() {
        /**
         *
         */
        this.removeEventListener('touchstart', this._handleTouchStart);
        this.removeEventListener('touchmove', this._handleTouchMove);
    
    }
};

u.CarouselSwipe.xDown = null;
u.CarouselSwipe.yDown = null;
u.CarouselSwipe.register('u-carousel-swipe');